import React, { Component } from "react";
import { gql } from "@apollo/client";
import { apolloClient } from "../../index";
import { notify } from "../Notify/Notify";
import "./FeedbackModal.scss";
import Modal from "react-bootstrap/Modal";
import help from "../../assets/icons/header/help.svg";
import closeIcon from "../../assets/close.svg";

class FeedbackModal extends Component {
  state = {
    showFeedbackModal: false,
    type: "",
    description: "",
  };

  componentDidUpdate(prevProps) {
    if (this.props !== prevProps) {
      this.setState({
        type: "",
        description: "",
        showFeedbackModal: false,
      });
    }
  }

  openNotificationDialog = () => {
    let isOpen = !this.state.showFeedbackModal;
    if (isOpen) {
      this.setState({ showFeedbackModal: isOpen, type: "", description: "" });
    } else {
      this.closeNotificationDialog();
    }
  };

  handleClose = () => {
    this.setState({ showFeedbackModal: false });
  };

  hasValidValues = () => {
    return (
      this.state.type !== "" &&
      this.state.type !== "select" &&
      this.state.description.trim().length > 0
    );
  };

  onChangeOption = (e) => {
    this.setState({ type: e.target.value });
  };

  sendFeedback = (e) => {
    e.preventDefault();
    const variables = {
      subject: this.state.type,
      description: this.state.description,
    };

    apolloClient
      .mutate({
        mutation: gql`
          mutation createFeedback($subject: String!, $description: String!) {
            createFeedback(subject: $subject, description: $description) {
              success
            }
          }
        `,
        variables: variables,
      })
      .then((result) => {
        if (result.data.createFeedback.success) {
          this.setState({
            type: "",
            description: "",
            showFeedbackModal: false,
          });
          const title = "Success";
          const detail = "Email sent successfully to tikler support team!";
          const type = "success";
          notify(title, detail, type);
        }
      })
      .catch((e) => {
        this.setState({ showFeedbackModal: false });
        const title = "Error";
        const detail = "Something went wrong try again later!";
        const type = "error";
        notify(title, detail, type);
      });
  };

  render() {
    return (
      <>
        <div className="feedback-icon-container">
          <div className="feedback">
            <img
              className="feedback-icon"
              onClick={this.openNotificationDialog}
              src={help}
              alt="feedback"
            />
          </div>
        </div>

        <Modal
          className="feedback-modal"
          centered
          show={this.state.showFeedbackModal}
          onHide={this.handleClose}
        >
          <div className="feedback-modal-content">
            <div className="header">
              <h3 className="title is-size-h4 bold">
                Have feedback? Let's hear it!
              </h3>
              <img
                className="close"
                src={closeIcon}
                alt="close"
                onClick={this.handleClose}
              />
            </div>

            <div className="body">
              <div className="form-groups">
                <div className="form-group">
                  <label>
                    <strong>I want to*</strong>
                  </label>
                  <select name="type" onChange={this.onChangeOption}>
                    <option value="select">Select an option</option>
                    <option value="suggestion">Leave a suggestion</option>
                    <option value="bug">Report a bug</option>
                    <option value="enhancement">
                      Recommend an enhancement
                    </option>
                    <option value="question">Ask a question</option>
                  </select>
                </div>

                <div className="form-group description-form-group">
                  <label>
                    <strong>Describe the situation*</strong>
                  </label>
                  <textarea
                    rows="5"
                    wrap="soft"
                    name="description"
                    className="form-control description"
                    value={this.state.description}
                    onChange={(e) =>
                      this.setState({ description: e.target.value })
                    }
                  />
                </div>
              </div>
            </div>

            <div className="footer">
              <button
                className="btn-tertiary cancel-button"
                onClick={this.handleClose}
              >
                Cancel
              </button>
              <button
                className="btn-primary create-button"
                disabled={!this.hasValidValues()}
                onClick={(event) => this.sendFeedback(event)}
              >
                Send Feedback
              </button>
            </div>
          </div>
        </Modal>
      </>
    );
  }
}

export default FeedbackModal;
